export default {
  navTicket: state => state.navTicket,
  numberOfTicket: state => state.numberOfTicket,
  sidebarTicket: state => state.sidebarTicket
}
